import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/Navbar";

const WORLDS = [
  { id: "aws", path: "/aws", accent: "#f59c1a" },
  { id: "martech", path: "/martech", accent: "#ca3b42" },
  { id: "people", path: "/people-hr", accent: "#0d9488" },
];

const HomeB = () => {
  const { t } = useLang();
  const [hover, setHover] = useState(null);
  const navigate = useNavigate();

  return (
    <div data-testid="home-b" className="min-h-[100svh] bg-[#FAFAFD] text-[#353535] flex flex-col">
      <div className="flex items-center justify-between px-5 sm:px-8 pt-6">
        <Logo />
        <LangToggle />
      </div>
      <div className="flex-1 flex flex-col px-5 sm:px-8 py-8 gap-3 max-w-[1400px] w-full mx-auto">
        {WORLDS.map((w, i) => {
          const c = t.gateway.worlds[w.id];
          const active = hover === w.id;
          return (
            <motion.div
              key={w.id}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 + i * 0.1 }}
              className="flex transition-all duration-500"
              style={{ flexGrow: active ? 1.8 : 1, flexBasis: 0 }}
            >
              <button
                data-testid={`homeb-select-${w.id}`}
                onClick={() => navigate(w.path)}
                onMouseEnter={() => setHover(w.id)}
                onMouseLeave={() => setHover(null)}
                className="group relative w-full rounded-3xl text-left px-8 sm:px-12 flex items-center justify-between overflow-hidden transition-colors duration-500 border border-black/8"
                style={{ backgroundColor: active ? w.accent : "#ffffff" }}
              >
                <div>
                  <div className={`font-jbmono text-[10px] uppercase tracking-[0.25em] mb-2 transition-colors duration-500 ${active ? "text-white/80" : "text-[#999999]"}`}>
                    {c.tag}
                  </div>
                  <div className={`font-cabinet font-bold tracking-tight leading-none transition-all duration-500 ${active ? "text-white text-3xl sm:text-5xl" : "text-[#353535] text-2xl sm:text-4xl"}`}>
                    {c.name}
                  </div>
                  <p className={`mt-3 max-w-md text-sm font-jakarta transition-all duration-500 ${active ? "text-white/90 opacity-100" : "opacity-0 h-0"}`}>
                    {c.desc}
                  </p>
                </div>
                <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full transition-all duration-500 ${active ? "bg-white rotate-0" : "border border-black/15 rotate-45"}`} style={{ color: active ? w.accent : "#353535" }}>
                  <ArrowUpRight size={22} />
                </span>
              </button>
            </motion.div>
          );
        })}
      </div>
      <div className="pb-6" />
    </div>
  );
};

export default HomeB;
